import { MouseEventHandler } from 'react'
import { IoMdClose } from 'react-icons/io'

const Pill = ({
  label,
  onClick,
}: {
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
}) => {
  return (
    <button
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onClick(e)
      }}
      className="bg-white flex items-center border rounded-lg py-1 px-2 text-[#9B9696]  hover:text-black transition-colors duration-300"
    >
      <IoMdClose className="mr-1" />
      <span className="font-bold text-xs">{label.toUpperCase()}</span>
    </button>
  )
}
export default Pill
